import { Button } from '@appkit4/react-components';
import { BusinessUnitResponse } from '../../api/generated/models';
import useLocale from '../../locale/useLocale';
import { useGetV1IdentityUserInfo } from '../../api/generated/endpoint';

export interface IBusinessUnitManagementActionsCellProps {
    businessUnit: BusinessUnitResponse;
    displayRenameBusinessUnitModal: () => void;
    displayDeleteBusinessUnitModal: () => void;
}

const BusinessUnitManagementActionsCell = (
    props: IBusinessUnitManagementActionsCellProps
) => {
    const { l } = useLocale();

    /* Load current user info */
    const { data: userInfo } = useGetV1IdentityUserInfo({
        query: {
            staleTime: Infinity,
        },
    });

    return (
        <div>
            <div className="row actions-icons">
                <Button
                    className="col m-0 p-0 h-50"
                    kind="text"
                    icon="icon-edit-outline"
                    type="button"
                    role="button"
                    compact
                    onClick={() => {
                        props.displayRenameBusinessUnitModal();
                    }}
                    title={`${l('_editBusinessUnit')} ${
                        props.businessUnit.name
                    }`}
                />

                <Button
                    className="col m-0 p-0 h-50"
                    kind="text"
                    icon="icon-delete-outline"
                    type="button"
                    role="button"
                    compact
                    disabled={
                        userInfo?.businessUnitId === props.businessUnit.id
                    }
                    onClick={() => {
                        props.displayDeleteBusinessUnitModal();
                    }}
                    title={`${l('_deleteBusinessUnit')} ${
                        props.businessUnit.name
                    }`}
                />
            </div>
        </div>
    );
};

export default BusinessUnitManagementActionsCell;
